// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b32b6f2f72a85d9ab652","112":"aad277f3b78fe97e1524","113":"f722adc72e7b8d4ce0ce","160":"7fbfb74769c9f84e5990"}[chunkId] + ".chunk.js";
};